export default __webpack_public_path__ + "static/media/seta-para-baixo.2a2971ed.png";